export const CONDITION_GROUP_GAP = 2.75;
